import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

type DeltaDirection = "up" | "down" | "flat";

interface DeltaChipProps {
  delta?: number;
  value?: number;
  unit?: string;
  size?: "default" | "sm";
  className?: string;
}

export const DeltaChip = ({ delta, value, unit = "", size = "default", className }: DeltaChipProps) => {
  const actualValue = delta !== undefined ? delta : value ?? 0;
  const direction: DeltaDirection = actualValue > 0 ? "up" : actualValue < 0 ? "down" : "flat";
  
  const formatValue = (val: number) => {
    const abs = Math.abs(val);
    if (abs >= 1000000) return `${(abs / 1000000).toFixed(1)}M`;
    if (abs >= 1000) return `${(abs / 1000).toFixed(1)}K`;
    return abs.toFixed(1);
  };

  const Icon = direction === "up" ? ArrowUp : direction === "down" ? ArrowDown : Minus;

  const colorClasses = {
    up: "text-success bg-success-bg",
    down: "text-danger bg-danger-bg",
    flat: "text-muted-foreground bg-muted",
  };

  const sizeClasses = size === "sm" ? "text-xs px-1.5 py-0.5" : "text-xs px-2 py-1";
  const iconSize = size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-md font-medium tabular-nums transition-smooth",
        sizeClasses,
        colorClasses[direction],
        className
      )}
    >
      <Icon className={iconSize} />
      <span>
        {formatValue(actualValue)}{unit}
      </span>
    </div>
  );
};
